"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const spacing = {
    // 4px
    smallXX: '4px',
    // 8px
    smallX: '8px',
    // 16px
    small: '16px',
    // 24px
    medium: '24px',
    // 32px
    large: '32px',
    // 48px
    largeX: '48px',
    // 64px
    largeXX: '64px',
    // 128px
    largeXXX: '128px'
};
exports.default = spacing;
